module.exports = __webpack_public_path__ + "img/flower.4d49176f.png";